var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuNotes(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 19 22",
    fill: "none",
    className: "injected-svg",
    "data-src": "/icons/new/menu-notes.svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.222.508a.787.787 0 0 1 .78.68l.007.107v.786h.786a2.361 2.361 0 0 1 2.36 2.36v10.757h-3.939l-.161.006a2.361 2.361 0 0 0-2.193 2.187l-.007.169v3.94H3.208a2.36 2.36 0 0 1-2.361-2.361L.845 4.443a2.361 2.361 0 0 1 2.36-2.361l.785-.001v-.786a.787.787 0 0 1 1.567-.107l.008.107v.786h3.148v-.786a.787.787 0 0 1 1.567-.107l.008.107v.786h3.145v-.786a.787.787 0 0 1 .788-.787Zm3.473 16.265-4.267 4.265.001-3.478.008-.107a.786.786 0 0 1 .672-.673l.107-.007h3.479Zm-8.723-1.575H4.778l-.107.008a.787.787 0 0 0 0 1.56l.107.007h4.195l.107-.008a.787.787 0 0 0 0-1.56l-.107-.007h-.001Zm5.247-4.197H4.777l-.107.008a.788.788 0 0 0 0 1.559l.107.007h9.442l.107-.007a.788.788 0 0 0 0-1.56l-.107-.007h-.002Zm0-4.197H4.777l-.107.007a.787.787 0 0 0 0 1.56l.107.007h9.442l.107-.007a.787.787 0 0 0 0-1.56l-.107-.007h-.002Z",
    fill: "#949494"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuNotes);
export default __webpack_public_path__ + "static/media/menu-notes.d386b0a13f14f0803be1c8c1b75b39e7.svg";
export { ForwardRef as ReactComponent };